import { Box } from '@material-ui/core';
import { Canvas } from '@react-three/fiber';
import PropTypes from 'prop-types';

import AnimatedKoin from './AnimatedKoin';

function CanvaKoin({ widthValue, heightValue }) {
  return (
    <Box style={{ width: widthValue, height: heightValue }}>
      <Canvas>
        <pointLight position={[2, 1, 4]} intensity={100} />
        <pointLight position={[-2, 1, 4]} intensity={50} />
        <AnimatedKoin position={[0, 0, 2]} rotate={[0, 4, 4]} />
      </Canvas>
    </Box>
  );
}

export default CanvaKoin;

CanvaKoin.propTypes = {
  widthValue: PropTypes.number.isRequired,
  heightValue: PropTypes.number.isRequired,
};
